import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withTranslation, Trans } from "react-i18next";
import swal from "sweetalert";
import { connect } from "react-redux";
import ReactPlayer from "react-player";
import Grid from "@material-ui/core/Grid";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import LinkIcon from "@material-ui/icons/Link";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import MapIcon from "@material-ui/icons/Map";
import ScheduleIcon from "@material-ui/icons/Schedule";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import Link from "@material-ui/core/Link";

import imgUrl from "../../assets/images/imageUrl.js";
import Services from "../../api/api";
import Knowledge from "./Knowledge";
import DialogBoxTextArea from "../DialogBox/DialogBoxTextArea";
import DialogBoxShareOnSocialMedia from "../DialogBox/DialogBoxShareOnSocialMedia";
import CommentList from "../Comment/CommentList";
import Slider from "react-slick";
import OffileDb from '../../config/pouchDB';
import KnowledgeDetailVideo from "./KnowledgeDetailVideo"
import annyang from 'annyang';
import { gaLogEvent } from "../../helpers/analytics";

import {
  setChatType,
  setSelectedComponentObject,
  setBottomNavComponentObject,
  partialSetSelectedComponentObject,
  setcomponentbgcolor
} from "../../redux/actions/appActions";

class knowledgeDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLiked: false,
      totalLikes: null,
      totalComments: null,
      dialogBoxIsOpen: false,
      socialDialogBoxIsOpen: false,
      commentList: [],
      isPlay: false,
      currentVideoSlide: 0,
      videoFlag: []
    };
    this.nextClick = this.nextClick.bind(this);
    this.afterChange = this.afterChange.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
  }

  componentDidMount() {
    gaLogEvent("Knowledge details", '', '');
    OffileDb.setDatabase()

    if (!this.props.location.state) {
      this.props.history.push("/layout");
    }

    const { state } = { ...this.props.location };
    // const { state } = { ...location };

    if (!state) {
      return;
    }



    this.setState({
      totalLikes: state.totalLikes,
      isLiked: state.isLiked,
      totalComments: state.totalComments,
    });
    this.createVideoObj(state);
    this.getContentWiseComments(state);
    var that = this;
    // annyang.addCallback('resultNoMatch', function(phrases) {
    //   if(phrases != null && phrases.length > 0){
    //     console.log('Speech recognized : ' + phrases[0]);
    //     var triggerFlag = false;
    //     var triggerWords = ["view", "take me", "reveal", "display", "exhibit", "present", "choose", "pick", "select", "open", "show", "click", "direct", "navigate", "home", "buksan", "bukas", "ipakita", "go back", "Open", "play"];
    //     for(var str of triggerWords) {
    //       if(phrases[0].includes(str)){
    //           triggerFlag = true;
    //       }
    //     }
    //     if(triggerFlag === true) {
    //       if(phrases[0].includes("play first")) {
    //         var temp = that.state.videoFlag;
    //         temp[0] = true;
    //         that.setState({videoFlag:temp})
    //       }
    //     }
    //   }
    // });
  }

  getContentWiseComments(contentobj) {
    this.loadOfflineData(contentobj)
    if (navigator.onLine) {
      let params = {
        communityId: this.props.communityuid,
        contentId: contentobj.contentId,
      };
      var dbid = 'KnowledgeComment-' + contentobj.contentId
      Services.getContentWiseComments(params).then((res) => {
        try{
          if (res.data.status == 200) {
            this.setState({
              commentList: res.data.data,
            });
            OffileDb.setData(dbid, res.data.data)
          }
        }catch(err){
          console.log("err::", err)
        }
      })
        .catch((err) => {
          console.error("err>>", err);
        });
    }
  }

  loadOfflineData(contentobj) {
    var that = this
    var dbid = 'KnowledgeComment-' + contentobj.contentId
    OffileDb.getData(dbid).then(function (result) {
      if (!result.status && result.status != 404) {
        that.setState({
          commentList: result.data,
        });
      }
    });
  }

  addComment() {
    this.setState({
      dialogBoxIsOpen: true,
    });
  }

  onLikeUnlike(contentobj) {
    if (this.state.isLiked) {
      this.unlikeContent(contentobj);
    } else {
      this.likeContent(contentobj);
    }
  }

  likeContent(contentobj) {
    let params = {
      communityId: this.props.communityuid,
      contentId: contentobj.contentId,
      contentName: contentobj.contentName,
      profileLink: "",
      userId: JSON.parse(localStorage.getItem("obj")).userId,
      userName: "",
    };
    Services.likeContent(params).then((res) => {
      try{
        if (res.data.status == 200) {
          this.setState({
            totalLikes: res.data.data.totalLikes,
            isLiked: true,
          });
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  unlikeContent(contentobj) {

    let params = {
      communityId: this.props.communityuid,
      contentId: contentobj.contentId,
      contentName: contentobj.contentName,
      profileLink: "",
      userId: JSON.parse(localStorage.getItem("obj")).userId,
      userName: "",
    };
    Services.unlikeContent(params).then((res) => {
      try{
        if (res.data.status == 200) {
          this.setState({
            totalLikes: res.data.data.totalLikes,
            isLiked: false,
          });
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  addCommentToContent(contentobj, comment) {
    let params = {
      comment: comment,
      communityId: this.props.communityuid,
      contentId: contentobj.contentId,
      contentName: contentobj.contentName,
      profileLink: "",
      userId: JSON.parse(localStorage.getItem("obj")).userId,
      userName: "",
    };
    console.log(params)
    Services.addCommentToContent(params).then((res) => {
      try{
        if (res.data.status == 200) {
          this.setState(
            {
              dialogBoxIsOpen: false,
              totalComments: res.data.data.totalComments,
            },
            () => {
              this.getContentWiseComments(contentobj);
            }
          );
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  toggleDialogBox(status) {
    this.setState({
      dialogBoxIsOpen: status,
    });
  }

  toggleSocialDialogBox(status) {
    this.setState({
      socialDialogBoxIsOpen: status,
    });
  }


  createVideoObj(state) {
    if (state.contentList &&
      state.contentList.length > 0 &&
      state.contentList[0].infographics &&
      state.contentList[0].infographics.video &&
      state.contentList[0].infographics.video.length > 0) {
      var len = state.contentList[0].infographics.video.length
      this.setState({ videoFlag: Array(len).fill(false) })
    }
  }

  nextClick(e) {
    var arr = this.state.videoFlag
    arr[e] = false;
    this.setState({
      videoFlag: arr
    })
  }

  afterChange(current) {
    // console.log(current)
    //console.log(this.state.videoFlag)
    // this.setState({
    //   currentVideoSlide: current,
    //   isPlay:false
    // })
  }

  onPlay(key) {
    var arr = this.state.videoFlag
    arr[key] = true;
    this.setState({
      videoFlag: arr
    })
    //this.setState({isPlay: true})
  }


  onPause(key) {
    var arr = this.state.videoFlag
    arr[key] = false;
    this.setState({
      videoFlag: arr
    })
    //this.setState({isPlay: false})
  }

  gotoGetAccess() {
    let getNearmeObj = {
      name: "Nearme",
      id: 2,
      path: "nearme",
    };

    let bgcolor = this.getcomponetColor('nearme')
    this.props.setcomponentbgcolor(bgcolor)
    localStorage.setItem('componentbgcolor', bgcolor)
    this.props.setBottomNavComponentObject(getNearmeObj);
    this.props.partialSetSelectedComponentObject(getNearmeObj);
    this.props.history.push({
      pathname: "/layout/nearme",
      state: this.props.knowledgeObj,
    });
  }

  gotoGetInvolved() {
    let getInvolvedObj = {
      name: "Services",
      id: 6,
      path: "services",
    };

    this.props.setBottomNavComponentObject(getInvolvedObj);
    this.props.partialSetSelectedComponentObject(getInvolvedObj);
    let bgcolor = this.getcomponetColor('services')
    localStorage.setItem('componentbgcolor', bgcolor)
    this.props.setcomponentbgcolor(bgcolor)
    this.props.history.push("/layout/Services");
  }

  gotoGetConnected() {
    let getConnectedObj = {
      name: "peerchat",
      id: 5,
      path: "peerchat",
    };

    this.props.setBottomNavComponentObject(getConnectedObj);
    this.props.partialSetSelectedComponentObject(getConnectedObj);
    let bgcolor = this.getcomponetColor('peerchat')
    localStorage.setItem('componentbgcolor', bgcolor)
    this.props.setcomponentbgcolor(bgcolor)
    this.props.history.push("/layout/peerchat");
  }

  getcomponetColor(linkpath) {
    var menulist = JSON.parse(localStorage.getItem("menuList"));
    if (menulist) {
      var obj = menulist.filter(obj => obj.path == linkpath);
      if (obj.length > 0) {
        return obj[0].layout.componentbgcolor
      }
    }
  }

  preventDefault = (event) => event.preventDefault();

  getHttpsUrl(iconurl) {
    var spliurtl = iconurl.split("://")
    let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
    return myUrl;
  }


  render() {
    const { state } = { ...this.props.location };
    const { t } = this.props;
    const { templateID } = this.props;
    let colorStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    let bgStyles = templateID == 2 ? { backgroundImage: `url(${state.contentList[0].backgroundImage})` } : {};
    let fillStyles = templateID == 2 ? { fill: this.props.componentbgcolor } : {};
    var menulist = JSON.parse(localStorage.getItem("menuList"))
    // const { state } = { ...location };

    if (!state) {
      this.props.history.push("/layout/getknowledgeable");
      return null;
    }


    if (state && !state.contentList) {
      return null;
    }

    if (state && state.contentList && state.contentList.length == 0) {
      return null;
    }
    var settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      swipeToSlide: true,
      adaptiveHeight: true,
      slidesToScroll: 1,
      fade: false,
      beforeChange: this.nextClick,
      afterChange: this.afterChange,
    };

    console.log(this.state.videoFlag)

    return (
      <div className="gk-page getknowledge-page getknowledgeable_page">

        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }

        <div className="gridcontainer bg-knowledge" style={bgStyles}>
          <Grid
            container
            spacing={3}
            className="gridcontainer bg-knowledge-tab"
          >
            <Grid item xs={12} className="gkdivcontent zero knowledge-detail">
              {/* <div className="infolinkcontainer content-detail-action d-flex">
                <Link onClick={() => this.addComment(state)}>
                  <ChatBubbleOutlineIcon />
                  <span className="likecountholder">
                    {this.state.totalComments}
                  </span>
                </Link>
                <Link
                  className={this.state.isLiked ? "active" : ""}
                  onClick={() => this.onLikeUnlike(state)}
                >
                  <ThumbUpAltIcon />
                  <span className="likecountholder">
                    {this.state.totalLikes}
                  </span>
                </Link>
              </div> */}
              <div className="scrollablepost">
                <div className="infodetailedpostcontainer" style={templateID == 2 ? { background: "white" } : {}}>
                  {
                    state.contentList[0].logoURL ? (
                      <div className="avatarholder">
                        <p className="zero text-center">
                          <img className="oneimpactlogoimg" src={this.getHttpsUrl(state.contentList[0].logoURL)} />
                        </p>
                      </div>) : ('')
                  }
                  <div className="postcontainer">
                    <p className="posttitle mt-0 font-rubik" style={{ color: this.props.componentbgcolor }}>{state.contentList[0].title}</p>
                    <p className="postinfo">{state.contentList[0].shortDesc}</p>
                    <p className="postinfo">
                      <div dangerouslySetInnerHTML={{ __html: state.contentList[0].description }} />
                    </p>
                    <p className="infoupdatedate">
                      {state.contentList[0].date}
                    </p>
                  </div>
                  <div className="postcontainer">
                    <div className="row">
                      {state.contentList &&
                        state.contentList.length > 0 &&
                        state.contentList[0].infographics &&
                        state.contentList[0].infographics.redirect &&
                        state.contentList[0].infographics.redirect.length > 0 &&
                        state.contentList[0].infographics.redirect.map(
                          (url, idx) => {
                            return (
                              <div className="col-12 mb-10px">
                                {idx == 0 ?
                                  <label className="redirect-url">Website : </label>
                                  :
                                  <label className="redirect-url">Facebook : </label>
                                }
                                <Link
                                  className="redirect-url"
                                  href={url}
                                  onClick={() => this.preventDefault}
                                >
                                  {url}
                                </Link>
                              </div>
                            );
                          }
                        )}
                    </div>
                  </div>
                </div>


                <div>

                  {state.contentList &&
                    state.contentList.length > 0 &&
                    state.contentList[0].infographics &&
                    state.contentList[0].infographics.video &&
                    state.contentList[0].infographics.video.length > 0 && (
                      <p className="text-center championvideobig">
                        <Slider {...settings} className="slider">
                          {
                            state.contentList[0].infographics.video.map(
                              (url, key) => {
                                var controflg = state.contentList[0].infographics.video[key].includes('vimeo')
                                return (
                                  <ReactPlayer
                                    url={state.contentList[0].infographics.video[key]}
                                    width={"100%"}
                                    height={200}

                                    style={{ marginTop: "0px" }}
                                    playing={this.state.videoFlag[key]}
                                    onPlay={() => this.onPlay(key)}
                                    onPause={() => this.onPause(key)}
                                    controls={controflg}
                                  />
                                )
                              }
                            )}
                        </Slider>
                      </p>
                    )
                  }
                  {state.contentList &&
                    state.contentList.length > 0 &&
                    state.contentList[0].infographics &&
                    state.contentList[0].infographics.image &&
                    state.contentList[0].infographics.image.length > 0 && (
                      <p className="text-center championvideobig">
                        <Slider {...settings} className="slider">
                          {
                            state.contentList[0].infographics.image.map(
                              (url, key) => {
                                return (<img
                                  src={state.contentList[0].infographics.image[key]}
                                  width={"100%"}
                                  height={200}
                                  light={true}
                                  style={{ marginTop: "0px" }}
                                />)
                              }
                            )
                          }

                        </Slider>
                      </p>
                    )
                  }
                </div>

                <div className="knowledge-accordian-row">
                  {state.hasChild && <Knowledge parentKnowledgeObj={state} />}
                </div>
                {/* <div className="posticoncontainer" style={templateID == 2 ? { background: "white" } : {}}>
                  <p className="postinfo">
                    <Trans> {t("Click the icon below to access all TB care and support services")} </Trans>

                  </p>
                  {/* <div className="subnavcontainer" style={{ display: "flex" }}>
                    <p className="mapiconcontainer">
                      <MapIcon onClick={() => this.gotoGetAccess()} style={{ fill: this.props.componentbgcolor }} />
                      <span><Trans> {t("Get Access")} </Trans></span>
                    </p>
                    <p className="mapiconcontainer">
                      <QuestionAnswerIcon onClick={() => this.gotoGetConnected()} style={{ fill: this.props.componentbgcolor }} />
                      <span><Trans> {t("Get Connected")} </Trans></span>
                    </p>
                    <p className="mapiconcontainer">
                      <ScheduleIcon onClick={() => this.gotoGetInvolved()} style={{ fill: this.props.componentbgcolor }} />

                      <span><Trans> {t("Get Involved")} </Trans></span>
                    </p>
                  </div> */}
                </div>
                {/* {this.state.commentList.length > 0 && (
                  <div className="posticoncontainer">
                    <p className="postinfo">{t('Comments')}</p>
                    <CommentList commentList={this.state.commentList} />
                  </div>
                )} */}
            </Grid>
          </Grid>
          <DialogBoxTextArea
            open={this.state.dialogBoxIsOpen}
            closeDialog={() => this.toggleDialogBox(false)}
            onSubmit={(content) => this.addCommentToContent(state, content)}
          />
          <DialogBoxShareOnSocialMedia
            open={this.state.socialDialogBoxIsOpen}
            contentObj={state}
            closeDialog={() => this.toggleSocialDialogBox(false)}
          />
        </div >
      </div >
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};

const transknowledgeDetail = withTranslation()(knowledgeDetail);
const routeknowledgeDetail = withRouter(transknowledgeDetail);
export default connect(mapStateToProps, {
  setBottomNavComponentObject,
  partialSetSelectedComponentObject,
  setcomponentbgcolor
})(routeknowledgeDetail);
